import sample from 'lodash/sample';
import { buildAction } from './helpers';
import { SET_MODAL_VISIBLE, SET_MODAL_PROPS } from '../constants';

export function showModal(props) {
  return function(dispatch) {
    dispatch(buildAction(SET_MODAL_PROPS, props));
    dispatch(buildAction(SET_MODAL_VISIBLE, true));
  };
}

export function hideModal() {
  return buildAction(SET_MODAL_VISIBLE, false);
}



// WEBPACK FOOTER //
// ./src/actions/modal.js